import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=e2a6d648&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=e2a6d648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a6d648",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2a6d648')) {
      api.createRecord('e2a6d648', component.options)
    } else {
      api.reload('e2a6d648', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=e2a6d648&scoped=true&", function () {
      api.rerender('e2a6d648', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2a5wxohQ4zPX9/JS/teamMember.vue"
export default component.exports